<template>
  <div id="app-wrapper" class="site-shell">
    <a href="#main-content" class="skip-link">Skip to content</a>
    <header class="site-header">
      <router-link to="/" class="site-brand" aria-label="This is me home"
        >this is me<span>.</span></router-link
      >
      <nav class="site-nav" aria-label="Main navigation">
        <router-link to="/dashboard">Your memories</router-link>
        <router-link
          v-if="
            !['dashboard', 'createMemory', 'login', 'signup'].includes(
              route.name
            )
          "
          to="/create"
          class="btn-primary"
          >Bring a photo to life ＋</router-link
        >
        <button v-if="authStore.user" @click="handleLogout">Log out</button>
        <router-link v-else-if="route.name !== 'login'" to="/login"
          >Log in</router-link
        >
      </nav>
    </header>
    <main id="main-content" class="site-main" tabindex="-1">
      <router-view />
    </main>
    <footer class="site-footer">
      <router-link to="/" class="site-brand">this is me.</router-link>
      <p>Their photographs. Their voice. For your family to keep.</p>
      <small>Made for your family.</small>
    </footer>
  </div>
</template>
<script setup>
import { useAuthStore } from "@/stores/auth";
import { useRouter, useRoute } from "vue-router";
const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const handleLogout = async () => {
  await authStore.logout();
  if (!authStore.user) router.push("/");
};
</script>
